import { NotPlayerDictionaryItem } from '@/models/dictionary/notPlayer';
import { useRemoteDictionaryHelpers } from '@/stores/utils/useRemoteDictionaryHelpers';
import { INotPlayerDictionaryApi } from '@/types';

export const useNotPlayerDictionary = defineStore('notPlayerDictionary', () => {
    const itemsAll = shallowRef<NotPlayerDictionaryItem[]>([]);

    const { itemById, nameById } = useRemoteDictionaryHelpers(itemsAll);

    function setData(data: INotPlayerDictionaryApi[]) {
        console.time('set-not-player-dictionary');
        itemsAll.value = data.map((item) => new NotPlayerDictionaryItem(item));
        console.timeEnd('set-not-player-dictionary');
    }

    const items = computed(() => itemsAll.value);

    return {
        items,
        itemById,
        nameById,
        setData,
    };
});
